import React, { FunctionComponent } from 'react';

import { BuildingTypeStep as CommonBuildingType } from 'scenes/common/components/Steps';
import { getApiData } from 'scenes/common/helpers/apiData';
import { InsuredItem } from 'scenes/common/types';

import {
  getBuildingType,
  getFreestandingMetreGap,
  getFreestandingStorey,
  getTerraceStorey,
  getTerraceStrata,
  getTownhouseStorey,
  getTownhouseStrata,
  getUnitLevel,
  getUnitStorey,
  getUnitStrata,
  hasBuildingCoverType,
} from 'scenes/home/selectors';
import { HomeFullPageProps } from 'scenes/home/types';

const BuildingTypeStep: FunctionComponent<HomeFullPageProps> = ({
  referenceData,
  funnelState,
  onNext,
}) => {
  const { buildingTypes } = getApiData(referenceData);

  return (
    <CommonBuildingType
      onNext={onNext}
      defaultStateValue={getBuildingType(funnelState)}
      options={buildingTypes}
      hideStrataQuestion={!hasBuildingCoverType(funnelState)}
      freestandingMetreGapValue={getFreestandingMetreGap(funnelState)}
      freestandingStoreyValue={getFreestandingStorey(funnelState)}
      terraceStoreyValue={getTerraceStorey(funnelState)}
      terraceStrataValue={getTerraceStrata(funnelState)}
      townhouseStoreyValue={getTownhouseStorey(funnelState)}
      townhouseStrataValue={getTownhouseStrata(funnelState)}
      unitStoreyValue={getUnitStorey(funnelState)}
      unitLevelValue={getUnitLevel(funnelState)}
      unitStrataValue={getUnitStrata(funnelState)}
      insuredItem={InsuredItem.Home}
    />
  );
};

export default BuildingTypeStep;
